import { useFeatureFlagEnabled } from "@posthog/react";
import {
  devOverridesEnabled,
  useDevOverridesStore,
  type MentorStoriesOverride,
} from "@/lib/hooks/admin/use-dev-overrides";

export const MENTOR_STORIES_FLAG = "enable-mentor-stories";

export function resolveMentorStoriesEnabled(params: {
  flagEnabled: boolean;
  override: MentorStoriesOverride;
  overridesEnabled: boolean;
}): boolean {
  const { flagEnabled, override, overridesEnabled } = params;

  if (overridesEnabled) {
    switch (override) {
      case "on":
        return true;
      case "off":
        return false;
      case "default":
        break;
      default: {
        const _exhaustive: never = override;
        return _exhaustive;
      }
    }
  }

  return flagEnabled;
}

export function useMentorStoriesEnabled(): boolean {
  const flagEnabled =
    useFeatureFlagEnabled(MENTOR_STORIES_FLAG) ?? import.meta.env.DEV;
  const override =
    useDevOverridesStore((s) => s.mentorStoriesOverride) ?? "default";

  return resolveMentorStoriesEnabled({
    flagEnabled,
    override,
    overridesEnabled: devOverridesEnabled,
  });
}
